// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-select{width:100%;position:relative;min-width:200px}.ui-select-option{padding:10px 17px;border-bottom:1px solid var(--q4s-neutral-200);font-style:normal;font-weight:400;font-size:18px;line-height:24px;cursor:pointer;background-color:var(--q4s-white);text-overflow:ellipsis;overflow-x:hidden}.ui-select-option.active,.ui-select-option:hover{background-color:var(--q4s-paper-50)}.ui-select .selector-icon{width:18px;height:18px;margin:0 10px -3px 0}", ""]);
// Exports
module.exports = exports;
